import React, { useState } from 'react';
import {
    FormSelectDropdownContainer,
    FormLabel,
    FormSelect,
    FormButton,
    DeleteModalOverlay,
    ModalContainer,
    ModalCloseButton,
    SpinningIcon
} from './DeleteModalElements';
import { FormH1 } from '../AccountForms/AccountElements';

const DeleteModal = ({ isOpen, onClose, deleteAccounts }) => {
    const [model, setModel] = useState('Hoth');
    const [riskTolerance, setRiskTolerance] = useState('Low');
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);


    if (!isOpen) return null;

    return (
        <DeleteModalOverlay>
            <ModalContainer>
                <FormH1>Are you sure you want to delete these accounts?</FormH1>
                <FormButton onClick={(e) => deleteAccounts(e)}>Delete</FormButton>
                <ModalCloseButton onClick={(e) => onClose(e)}>Cancel</ModalCloseButton>
            </ModalContainer>
        </DeleteModalOverlay>
    );
};


export default DeleteModal;
